import React from 'react'
import { Stack, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material'
import moment from 'moment/moment'
import { useState } from 'react'
import { Item } from '../../../common/snippets'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import { callAddFontNirmalaBold } from '../../BranchTransfer/fonts/Nirmala-bold'
import { callAddFontNirmalaNormal } from '../../BranchTransfer/fonts/Nirmala-normal'
import autoTable from 'jspdf-autotable'
import { Box, display } from '@mui/system'
import { backGroundColor, focusElemnt, getPaymentTypeBackground, getStatusBackground, navigation3 } from '../../../common/helper'
import AppsIcon from '@mui/icons-material/Apps'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import {
  excelHeader,
  gstColumnStyle,
  gstReportColumn,
  lrDetailPdfFooter,
  DrawCellDetail,
  DrawCellDetailNonGST,
  pdfHeaderColumn,
  pdfHeaderNonGST,
  pdfHeaderGST,
  DrawCellDetailGST,
  pdfHeaderGSTForBoth,
  pdfHeaderGSTFormattedLRNO,
  pdfHeaderNonGSTForBoth,
  pdfHeaderNonGSTFormattedLRNO,
  gstColumnStyleFormatedLR,
} from '../common/AcountingConstants'
import * as id from '../common/AcountingId'

const DetailedTable = ({
  loginData,
  tableData,
  fromDate,
  toDate,
  stateName,
  sourceCity,
  sourceBranch,
  destCity,
  destBranch,
  paymentType,
  gstPaidBy,
  bookingType,
  updateScreen,
  updateModal,
  columns,
  selectedFields,
  tableDataForGST,
  tableDataForNonGST,
  disableExcel, UseFormattedLRinReports
}) => {
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [showTable, setShowTable] = useState(true)
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  //const [manageColumn, setManageColumn] = useState(coloumnOnAccountDetails1)
  const printClick = (isSave) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const pdfHeaderGSTCol=UseFormattedLRinReports===0||UseFormattedLRinReports===1?pdfHeaderGST:UseFormattedLRinReports===2?pdfHeaderGSTFormattedLRNO:pdfHeaderGSTForBoth
    const pdfHeaderNonGSTCol=UseFormattedLRinReports===0||UseFormattedLRinReports===1?pdfHeaderNonGST:UseFormattedLRinReports===2?pdfHeaderNonGSTFormattedLRNO:pdfHeaderNonGSTForBoth
    const pdfColumns = pdfHeaderGSTCol.map((col) => {
      return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns1 = pdfHeaderNonGSTCol.map((col) => {
      return { header: col.pdfHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = pdfHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })

    const HeaderData = [
      {
        state: stateName,
        sourceCity: sourceCity,
        sourceBranch: sourceBranch,
        destCity: destCity,
        destBranch: destBranch,
        paymentType: paymentType,
        gstPaidBy: gstPaidBy,
        bookingType: bookingType?.name,
      },
    ]
    //bodyData for GST
    const bodyData = tableDataForGST?.map((item) =>
      item.isTotal || item.isHeading1
        ? item
        : {
          srNo: item.SN,
          LRNO: UseFormattedLRinReports===2?item.FormattedLRNO:item.LRNO + '\n' + item.BookingDateTime,
          FormattedLRNO: item.FormattedLRNO,
          CompStateName: item.CompanyName,
          StateName: item.StateName,
          SourceDestCity: item.SourceCity + '\n' + item.DestinationCity,
          SendNameSendGSTN: item.Sender + '\n' + item.SenderGSTN,
          RecNameRecGSTN: item.RecName + '\n' + item.ReceiverGSTN,
          payment: item.PaymentTypeName,
          EwayBillNo: item.EwayBillNo?.split('~')[0],
          BookingGst: item.BookingGst,
          bkgGSTInvNoDate: item.BookingGSTInv + '\n' + item.BookingGSTInvDate,
          BookingGSTAmt: item.BookingGSTAmt,
          DeliveryGST: item.DeliveryGST,
          delGSTInvNoDate: item.DelGSTInv + '\n' + item.DelGSTInvDate,
          DelGSTAmt: item.DelGSTAmt,
        }
    )
    //header for credit delivery
    bodyData?.unshift({
      srNo: 'SN',
      LRNO:UseFormattedLRinReports===2?'Formatted LRNO\nBkg. Date':'LR No.\nBkg. Date',
      FormattedLRNO: 'Formatted\nLRNO',
      CompStateName: 'Comp. Name',
      StateName: 'Src. State\nRcr. State',
      SourceDestCity: 'Src. City\nDest. City',
      SendNameSendGSTN: 'Sndr. Name\nSndr. GSTIN',
      RecNameRecGSTN: 'Rcvr. Name\nRcvr. GSTIN',
      payment: 'Payment\nType',
      EwayBillNo: 'Eway\nBill No.',
      BookingGst: 'Book\nGST',
      bkgGSTInvNoDate: 'Bkg.GST Inv No.\nBkg.GST Inv Date',
      BookingGSTAmt: 'Bkg.GST\nInv.Amt',
      DeliveryGST: 'Del.\nGST',
      delGSTInvNoDate: 'Del.GST Inv No.\nDel.GST Inv Date',
      DelGSTAmt: 'Del.GST\nInv.Amt',
      isHeading1: true,
    })
    bodyData?.unshift({
      srNo: 'Report View: Detailed',
      LRNO: 'Booking Type: GST Bookings',
      isSubHeading: true,
    })
    bodyData?.unshift({ srNo: 'GST Report', isSupHeading: true })
    // bodyData for Refund
    const bodyData1 = tableDataForNonGST?.map((item) =>
      item.isHeading || item.isSubHeading || item.isTotalRefund
        ? item
        : {
          SN: item.SN,
          BkgDt: item.BookingDateTime,
          LRNO: item.LRNO,
          FormattedLRNO: item.FormattedLRNO,
          CompStateName: item.CompanyName,
          StateName: item.StateName,
          SourceDestCity: item.SourceCity + '\n' + item.DestinationCity,
          Sender: item.Sender + '\n' + item.SenderGSTN,
          Receiver: item.RecName + '\n' + item.ReceiverGSTN,
          Consignment: item.SubType?.split('(')[0].trim(),
          PaymentType: item.PaymentTypeName,
          Freight: item.Freight,
          OtherCharges: item.OtherCharges,
          NetAmount: item.NetAmount,
        }
    )
    // const bodyData1 = tableDataRefund?.map((item) => item)
    const doc = new jsPDF({ orientation: 'L', format: [1754, 1240], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `GST Reports.pdf`,
      subject: 'GST Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        1: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        2: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        3: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        4: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        5: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        6: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        7: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        doc.text(
          `Booking Date: ${moment(fromDate).format('DD-MMM-YYYY')}  To  ${moment(toDate).format('DD-MMM-YYYY')} `,
          data.settings.margin.left,
          150
        )
        doc.text(`Report View: Detailed`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
      },
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: bodyData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      //---------------data of table-----------
      columnStyles: UseFormattedLRinReports===3?gstColumnStyleFormatedLR:gstColumnStyle,
      theme: 'grid',
      didParseCell: (data) => {
        DrawCellDetailGST(data,UseFormattedLRinReports)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | GST Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        lrDetailPdfFooter(data, loginData, totalPagesExp)
      },
      showHead: 'never',
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns1,
      body: bodyData1,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      //---------------data of table-----------
      columnStyles: {
        0: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        1: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        2: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        3: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        4: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        5: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        6: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        7: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        8: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        9: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        10: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        11: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        12: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        13: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      startY: doc.lastAutoTable.finalY,
      didParseCell: (data) => {
        DrawCellDetailNonGST(data,UseFormattedLRinReports)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | GST Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        lrDetailPdfFooter(data, loginData, totalPagesExp)
      },
      showHead: 'never',
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`GST Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('ownBooingDetailed').data = pdfUrl
        // document.getElementById('ownBooingDetailed').data = doc.output('datauristring', ' GST Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('ownBooingDetailed').data = pdfUrl
        // document.getElementById('ownBooingDetailed').data = doc.output('datauristring', ' GST Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    }
  }
  const handleRowClick = (url) => {
    window.open(url, '_blank') // Open the link in a new tab
  }
  const InsideRowContentForBoth = ({ item, index, selectedFields }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top' }}>
          {item.isTotal ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={UseFormattedLRinReports == 3 ? 7 : 6}
                // colSpan={Object.keys(selectedFields).length === 16 ? 8 : 10}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.srNo}
              </TableCell>
              {selectedFields.hasOwnProperty('Sender') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'left'}}
                >
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('Receiver') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'left' }}
                >
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('SubType') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'left',}}
                >
                </TableCell>
              )}
              <TableCell
                className="reportTD"
                colSpan={2}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
              </TableCell>
              {selectedFields.hasOwnProperty('Freight') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.Freight}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('OtherCharges') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.OtherCharges?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingGst') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'left' }}
                >
                  {item.BookingGst?.toFixed(1)}
                </TableCell>
              )}
              {/* {selectedFields.hasOwnProperty('NetAmount') && ( */}
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'left' }}
              >
                {item.NetAmount?.toFixed(1)}
              </TableCell>
              {/* )} */}
              {selectedFields.hasOwnProperty('GstPaidBy') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                ></TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingGSTInv') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                ></TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingGSTInvDate') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                ></TableCell>
              )}
              {/* <TableCell colSpan={3} style={{ background: '#EEEEEE' }}></TableCell> */}
              {/* ---------3data row---------- */}
              {selectedFields.hasOwnProperty('BookingGSTAmt') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.BookingGSTAmt?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingCGST') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.BookingCGST?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingSGST') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.BookingSGST?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingIGST') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.BookingIGST?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('DeliveryTaxableAmt') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.DeliveryTaxableAmt?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('DeliveryGST') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.DeliveryGST?.toFixed(1)}
                </TableCell>
              )}
              {/* -----------netamt------------ */}
              {/* {selectedFields.hasOwnProperty('NetAmount1') && ( */}
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.NetAmount?.toFixed(1)}
              </TableCell>
              {/* )} */}
              {selectedFields.hasOwnProperty('DelGSTInv') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                ></TableCell>
              )}
              {selectedFields.hasOwnProperty('DelGSTInvDate') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                ></TableCell>
              )}
              {/* <TableCell colSpan={2} style={{ background: '#EEEEEE' }}></TableCell> */}
              {selectedFields.hasOwnProperty('DelGSTAmt') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.DelGSTAmt?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('DeliveryCGST') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.DeliveryCGST?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('DeliverySGST') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.DeliverySGST?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('DeliveryIGST') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.DeliveryIGST?.toFixed(1)}
                </TableCell>
              )}
            </>
          ) : item.isTotalRefund ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={UseFormattedLRinReports == 3 ? 11:10}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.SN}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.Freight?.toFixed(1)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.OtherCharges?.toFixed(1)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.NetAmount?.toFixed(1)}
              </TableCell>
            </>
          ) : item.isSubHeading ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={7}
                style={{ fontSize: '14px', fontWeight: '500', textAlign: 'left', color: '#444', backgroundColor: '#bfe1ff' }}
              >
                {item.SN}
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={UseFormattedLRinReports == 3 ? 7 : 6}
                style={{ fontSize: '14px', fontWeight: '500', textAlign: 'right', color: '#444', backgroundColor: '#bfe1ff' }}
              >
                {item.BkgDt}
              </TableCell>
            </>
          ) : //-----non GST Table Header-----//
            item.isHeading ? (
              <>
                {Object.keys(item)
                  .filter((val) => val !== 'isHeading')
                  .map((i, index) => (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{
                        fontWeight: 'bold',
                        fontSize: '12px',
                        lineheight: '16px',
                        letterspacing: '0.24px',
                        fontWeight: '500',
                        textAlign: item.hasOwnProperty('RefundAmount') ? (index > 13 ? 'right' : 'left') : index > 9 ? 'right' : 'left',
                        color: '#444',
                        //backgroundColor: '#bfe1ff',e5f3ff
                        backgroundColor: '#e5f3ff',
                        position: 'sticky',
                        top: '55px',
                        whiteSpace: 'pre',
                      }}
                    >
                      {item[i]}
                    </TableCell>
                  ))}
              </>
            ) : //Non GST Table Data
              item.hasOwnProperty('BookingNONGST') ? (
                <>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left' }}
                  >
                    {item.SN}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                  >
                    {item.BookingDateTime !== '' ? moment(item.BookingDateTime).format('DD-MMM-YY') : ''}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                  >
                    <span style={{ color: '#0086ff' }}>{UseFormattedLRinReports === 2 ? item.FormattedLRNO : item.LRNO}</span>
                  </TableCell>
                  {
                    UseFormattedLRinReports === 3 &&
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                    >
                      {item.FormattedLRNO}
                    </TableCell>
                  }
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                  >
                    {item.CompanyName}
                    {/* <br />
                {item.StateName} */}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'pre' }}
                  >
                    {/* {item.CompanyName}
                <br /> */}
                    {item.StateName}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                  >
                    {item.SourceCity} <br />
                    {item.DestinationCity}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                  >
                    {item.Sender} <br />
                    {item.SenderGSTN}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left' }}
                  >
                    {item.RecName} <br />
                    {item.ReceiverGSTN}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                  >
                    {item.SubType?.split('(')[0].trim()}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left' }}
                  >
                    {/* {item.PaymentTypeName} */}
                    <span
                      style={{
                        backgroundColor: getPaymentTypeBackground(item?.PaymentTypeName),
                        padding: '2px 8px',
                        borderRadius: '30px',
                        textDecoration: item?.PaymentTypeName?.length > 7 ? 'underline' : '',
                      }}
                      title={item?.PaymentTypeName}
                    >
                      {item?.PaymentTypeName}
                    </span>
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.Freight}
                  </TableCell>

                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.OtherCharges}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.NetAmount}
                  </TableCell>
                </>
              ) : (
                <>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left' }}
                  >
                    {item.SN}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                  >
                    {item.BookingDateTime !== '' ? moment(item.BookingDateTime).format('DD-MMM-YY') : ''}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                  >
                    <span style={{ color: '#0086ff' }}>{UseFormattedLRinReports === 2 ? item.FormattedLRNO : item.LRNO}</span>
                  </TableCell>
                  {
                    UseFormattedLRinReports === 3 &&
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'pre' }}
                    >
                      {item.FormattedLRNO}
                    </TableCell>
                  }
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'pre' }}
                  >
                    {item.CompanyName}
                    {/* {item.StateName} */}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'pre' }}
                  >
                    {/* {item.CompanyName} <br /> */}
                    {item.StateName}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                  >
                    {item.SourceCity} <br />
                    {item.DestinationCity}
                  </TableCell>
                  {selectedFields.hasOwnProperty('Sender') && (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                    >
                      {item.Sender} <br />
                      {item.SenderGSTN}
                    </TableCell>
                  )}
                  {selectedFields.hasOwnProperty('Receiver') && (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left' }}
                    >
                      {item.RecName} <br />
                      {item.ReceiverGSTN}
                    </TableCell>
                  )}
                  {selectedFields.hasOwnProperty('SubType') && (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                    >
                      {item.SubType?.split('(')[0].trim()}
                    </TableCell>
                  )}
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left' }}
                  >
                    {/* {item.PaymentTypeName} */}
                    <span
                      style={{
                        backgroundColor: getPaymentTypeBackground(item?.PaymentTypeName),
                        padding: '2px 8px',
                        borderRadius: '30px',
                        textDecoration: item?.PaymentTypeName?.length > 7 ? 'underline' : '',
                      }}
                      title={item?.PaymentTypeName}
                    >
                      {item?.PaymentTypeName}
                    </span>
                  </TableCell>

                  <TableCell className="userwiseTD" colSpan={1} style={{ fontSize: '12px' }} title={item.Status}>
                    <span
                      className="status"
                      style={{
                        //  backgroundColor: backGroundColor[`${item.Status}`],
                        padding: '5px 10px 5px 10px',
                        borderRadius: '12px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {item.EwayBillNo?.split('~')[0]}
                    </span>
                  </TableCell>
                  {selectedFields.hasOwnProperty('Freight') && (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                    >
                      {item.Freight}
                    </TableCell>
                  )}
                  {selectedFields.hasOwnProperty('OtherCharges') && (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                    >
                      {item.OtherCharges}
                    </TableCell>
                  )}
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left' }}
                  >
                    {item.BookingGst}
                  </TableCell>
                  {/* {selectedFields.hasOwnProperty('NetAmount') && ( */}
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left' }}
                  >
                    {item.NetAmount}
                  </TableCell>
                  {/* )} */}
                  {selectedFields.hasOwnProperty('GstPaidBy') && (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                    >
                      {item.GstPaidBy === 'Tr' ? 'Transporter' : item.GstPaidBy === 'Cr' ? 'Consignor' : 'Consignee'}
                    </TableCell>
                  )}
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    <span style={{ color: '#0086ff' }} onClick={() => handleRowClick(item.BoookingGSTLink)}>
                      {item.BookingGSTInv}
                    </span>
                  </TableCell>

                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                  >
                    {item.BookingGSTInvDate !== '' ? moment(item.BookingGSTInvDate).format('DD-MMM-YY') : ''}
                  </TableCell>

                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BookingGSTAmt}
                  </TableCell>
                  {selectedFields.hasOwnProperty('BookingCGST') && (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
                    >
                      {item.BookingCGST} <br />
                    </TableCell>
                  )}
                  {selectedFields.hasOwnProperty('BookingSGST') && (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                    >
                      {item.BookingSGST}
                    </TableCell>
                  )}
                  {selectedFields.hasOwnProperty('BookingIGST') && (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                    >
                      {item.BookingIGST}
                    </TableCell>
                  )}
                  {selectedFields.hasOwnProperty('DeliveryTaxableAmt') && (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                    >
                      {item.DeliveryTaxableAmt}
                    </TableCell>
                  )}
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveryGST}
                  </TableCell>
                  {/* {selectedFields.hasOwnProperty('NetAmount1') && ( */}
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.NetAmount}
                  </TableCell>
                  {/* )} */}
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    <span style={{ color: '#0086ff' }} onClick={() => handleRowClick(item.DeliveryGSTLink)}>
                      {item.DelGSTInv}
                    </span>
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
                  >
                    {item.DelGSTInvDate !== '' ? moment(item.DelGSTInvDate).format('DD-MMM-YY') : ''}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DelGSTAmt}
                  </TableCell>
                  {selectedFields.hasOwnProperty('DeliveryCGST') && (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                    >
                      {item.DeliveryCGST}
                    </TableCell>
                  )}
                  {selectedFields.hasOwnProperty('DeliverySGST') && (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                    >
                      {item.DeliverySGST}
                    </TableCell>
                  )}
                  {selectedFields.hasOwnProperty('DeliveryIGST') && (
                    <TableCell
                      className="reportTD"
                      colSpan={1}
                      style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                    >
                      {item.DeliveryIGST}
                    </TableCell>
                  )}
                </>
              )}
        </TableRow>
      </>
    )
  }
  const InsideRowContentForExcel = ({ item, index, selectedFields }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top', fontSize: '16px' }}>
          {item.isTotal ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={UseFormattedLRinReports == 3 ? 7 : 6}
                // colSpan={Object.keys(selectedFields).length === 16 ? 8 : 10}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
                {item.srNo}
              </TableCell>
              {selectedFields.hasOwnProperty('Sender') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'left' }}
                >
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('Receiver') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'left' }}
                >
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('SubType') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'left', }}
                >
                </TableCell>
              )}
              <TableCell
                className="reportTD"
                colSpan={2}
                style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
              >
              </TableCell>
              {selectedFields.hasOwnProperty('Freight') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                  {item.Freight}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('OtherCharges') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                  {item.OtherCharges?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingGst') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                  {item.BookingGst?.toFixed(1)}
                </TableCell>
              )}
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.NetAmount?.toFixed(1)}
              </TableCell>
              {selectedFields.hasOwnProperty('GstPaidBy') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}
                ></TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingGSTInv') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}
                ></TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingGSTInvDate') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}
                ></TableCell>
              )}
              {/* <TableCell colSpan={3} style={{ background: '#EEEEEE' }}></TableCell> */}
              {/* ---------3data row---------- */}
              {selectedFields.hasOwnProperty('BookingGSTAmt') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                  {item.BookingGSTAmt?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingCGST') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                  {item.BookingCGST?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingSGST') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                  {item.BookingSGST?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingIGST') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                  {item.BookingIGST?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('DeliveryTaxableAmt') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                  {item.DeliveryTaxableAmt?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('DeliveryGST') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                  {item.DeliveryGST?.toFixed(1)}
                </TableCell>
              )}
              {/* -----------netamt------------ */}
              {/* {selectedFields.hasOwnProperty('NetAmount1') && ( */}
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.NetAmount?.toFixed(1)}
              </TableCell>
              {/* )} */}
              {selectedFields.hasOwnProperty('DelGSTInv') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}
                ></TableCell>
              )}
              {selectedFields.hasOwnProperty('DelGSTInvDate') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}
                ></TableCell>
              )}
              {/* <TableCell colSpan={2} style={{ background: '#EEEEEE' }}></TableCell> */}
              {selectedFields.hasOwnProperty('DelGSTAmt') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                  {item.DelGSTAmt?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('DeliveryCGST') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                  {item.DeliveryCGST?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('DeliverySGST') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                  {item.DeliverySGST?.toFixed(1)}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('DeliveryIGST') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                  {item.DeliveryIGST?.toFixed(1)}
                </TableCell>
              )}
            </>
          ) : item.isTotalRefund ? (
            <>
              <TableCell className="reportTD" colSpan={UseFormattedLRinReports===3?11:10} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.SN}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.Freight?.toFixed(1)}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.OtherCharges?.toFixed(1)}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: '#EEEEEE', fontWeight: '700', textAlign: 'right' }}>
                {item.NetAmount?.toFixed(1)}
              </TableCell>
            </>
          ) : item.isSubHeading ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={7}
                style={{ fontWeight: '500', textAlign: 'left', color: '#444', backgroundColor: '#bfe1ff' }}
              >
                {item.SN}
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={UseFormattedLRinReports===3?7:6}
                style={{ fontWeight: '500', textAlign: 'right', color: '#444', backgroundColor: '#bfe1ff' }}
              >
                {item.BkgDt}
              </TableCell>
            </>
          ) : item.isHeading ? (
            <>
              {Object.keys(item)
                .filter((val) => val !== 'isHeading')
                .map((i, index) => (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      fontSize: '16px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      textAlign: item.hasOwnProperty('RefundAmount') ? (index > 13 ? 'right' : 'left') : index > 9 ? 'right' : 'left',
                      color: '#444',
                      backgroundColor: '#e5f3ff',
                      position: 'sticky',
                      top: '55px',
                      whiteSpace: 'pre',
                    }}
                  >
                    {item[i]}
                  </TableCell>
                ))}
            </>
          ) : item.hasOwnProperty('BookingNONGST') ? (
            <>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
                {item.SN}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.BookingDateTime !== '' ? moment(item.BookingDateTime).format('DD-MMM-YY') : ''}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                <span style={{ color: '#0086ff' }}>{UseFormattedLRinReports === 2 ? item.FormattedLRNO : item.LRNO}</span>
              </TableCell>
              {
                UseFormattedLRinReports === 3 &&
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'pre' }}
                >
                  {item.FormattedLRNO}
                </TableCell>
              }
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'pre' }}
              >
                {item.CompanyName}
                {/* <br />
                {item.StateName} */}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'pre' }}
              >
                {/* {item.CompanyName} 
                <br /> */}
                {item.StateName}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.SourceCity} <br />
                {item.DestinationCity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.Sender} <br />
                {item.SenderGSTN}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
                {item.RecName} <br />
                {item.ReceiverGSTN}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.SubType?.split('(')[0].trim()}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
                {item.PaymentTypeName}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.Freight}
              </TableCell>

              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.OtherCharges}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.NetAmount}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
                {item.SN}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.BookingDateTime !== '' ? moment(item.BookingDateTime).format('DD-MMM-YY') : ''}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
                <span style={{ color: '#0086ff' }}>{UseFormattedLRinReports === 2 ? item.FormattedLRNO : item.LRNO}</span>
              </TableCell>
              {
                UseFormattedLRinReports === 3 &&
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: 'F5FAFE', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'pre' }}
                >
                  {item.FormattedLRNO}
                </TableCell>
              }
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'pre' }}
              >
                {item.CompanyName}
                {/* <br />
                {item.StateName} */}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'pre' }}
              >
                {/* {item.CompanyName} <br /> */}
                {item.StateName}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.SourceCity} <br />
                {item.DestinationCity}
              </TableCell>
              {selectedFields.hasOwnProperty('Sender') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                >
                  {item.Sender} <br />
                  {item.SenderGSTN}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('Receiver') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
                  {item.RecName} <br />
                  {item.ReceiverGSTN}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('SubType') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                >
                  {item.SubType?.split('(')[0].trim()}
                </TableCell>
              )}
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
                {item.PaymentTypeName}
              </TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ fontSize: '12px' }} title={item.Status}>
                <span
                  className="status"
                  style={{
                    //  backgroundColor: backGroundColor[`${item.Status}`],
                    padding: '5px 10px 5px 10px',
                    borderRadius: '12px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {item.EwayBillNo?.split('~')[0]}
                </span>
              </TableCell>
              {selectedFields.hasOwnProperty('Freight') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                  {item.Freight}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('OtherCharges') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                  {item.OtherCharges}
                </TableCell>
              )}
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
                {item.BookingGst}
              </TableCell>
              {/* {selectedFields.hasOwnProperty('NetAmount') && ( */}
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
                {item.NetAmount}
              </TableCell>
              {/* )} */}
              {selectedFields.hasOwnProperty('GstPaidBy') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                  {item.GstPaidBy === 'Tr' ? 'Transporter' : item.GstPaidBy === 'Cr' ? 'Consignor' : 'Consignee'}
                </TableCell>
              )}
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                <span style={{ color: '#0086ff' }} onClick={() => handleRowClick(item.BoookingGSTLink)}>
                  {item.BookingGSTInv}
                </span>
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
              >
                {item.BookingGSTInvDate !== '' ? moment(item.BookingGSTInvDate).format('DD-MMM-YY') : ''}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.BookingGSTAmt}
              </TableCell>
              {selectedFields.hasOwnProperty('BookingCGST') && (
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
                >
                  {item.BookingCGST} <br />
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingSGST') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                  {item.BookingSGST}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('BookingIGST') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                  {item.BookingIGST}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('DeliveryTaxableAmt') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                  {item.DeliveryTaxableAmt}
                </TableCell>
              )}
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.DeliveryGST}
              </TableCell>
              {/* {selectedFields.hasOwnProperty('NetAmount1') && ( */}
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.NetAmount}
              </TableCell>
              {/* )} */}
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                <span style={{ color: '#0086ff' }} onClick={() => handleRowClick(item.DeliveryGSTLink)}>
                  {item.DelGSTInv}
                </span>
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
              >
                {item.DelGSTInvDate !== '' ? moment(item.DelGSTInvDate).format('DD-MMM-YY') : ''}
              </TableCell>
              <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                {item.DelGSTAmt}
              </TableCell>
              {selectedFields.hasOwnProperty('DeliveryCGST') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                  {item.DeliveryCGST}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('DeliverySGST') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                  {item.DeliverySGST}
                </TableCell>
              )}
              {selectedFields.hasOwnProperty('DeliveryIGST') && (
                <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right' }}>
                  {item.DeliveryIGST}
                </TableCell>
              )}
            </>
          )}
        </TableRow>
      </>
    )
  }
  return (
    <>
      <Box className="userReport" style={{ display: 'flex', width: '100%', height: '40px', padding: '12px 0px', marginRight: '0px' }}>
        <Box style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}>
          <h3 style={{ textAlign: 'left', color: '#444', paddingLeft: '16px' }}>Report For: GST Report</h3>
          <Box
            style={{
              height: '32px',
              display: 'flex',
              padding: '18px',
              justifycontent: 'center',
              alignitems: 'center',
              gap: '6px',
            }}
            id="dispatchReportManageColumn"
            tabIndex={0}
            onClick={() => updateModal(true, 'showManageColumn1')}
          >
            <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
              <AppsIcon />
            </span>
            <span tabIndex={0} style={{ fontWeight: 'bold' }}>
              MANAGE COLUMNS
            </span>
          </Box>
        </Box>
        <Box
          className="userReport-buttons"
          style={{
            display: 'flex',
            width: '50%',
            justifyContent: 'end',
            alignItems: 'center',
            paddingRight: '16px',
          }}
        >
          {showTable ? (
            <>
              {disableExcel ? (
                <Box>
                  <Button variant="outlined" className="userWisereporttembtn" disabled={true}>
                    Export to Excel
                  </Button>
                </Box>
              ) : (
                <Box onKeyDown={(e) => navigation3(e, 'gstExportAsPdfBtn', id.gstSplitButton, () => { })}>
                  <ReactHtmlTableToExcel
                    id="gstExportToExlbtn"
                    // id="test-table-xls-button"
                    className="userWisereporttemExcelBtn"
                    table="table-to-xls1"
                    filename={`GST Report ${currentDateTime}`}
                    sheet="tablexls"
                    buttonText="Export to Excel"
                  />
                </Box>
              )}
              <Box>
                <Button
                  variant="outlined"
                  id="gstExportAsPdfBtn"
                  onKeyDown={(e) =>
                    navigation3(e, 'gstPrintBtn', 'gstExportToExlbtn', () => {
                      printClick(true)
                    })
                  }
                  className="userWisereporttembtn"
                  onClick={() => printClick(true)}
                >
                  Export to Pdf
                </Button>
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  onKeyDown={(e) =>
                    navigation3(e, id.gstFromDate, 'gstExportAsPdfBtn', () => {
                      printClick(false)
                    })
                  }
                  id="gstPrintBtn"
                  className="userWisereporttembtn"
                  onClick={() => printClick(false)}
                >
                  Print
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box>
                <Button
                  id="backBtn"
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => (setShowTable(true), updateScreen())}
                >
                  Back
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Box>
      {showTable ? (
        <>
          <Stack sx={{ marginLeft: 2, marginRight: 2, height: 440, paddingTop: '10px' }} className="changeScrollColor">
            <TableContainer className="scroll" style={{ borderRadius: '6px', border: '1px solid rgb(224 224 224)' }}>
              {/* --------------TableForExcel-------------- */}
              <Table id="table-to-xls1" className="table1 table-Report" size="small" aria-label="a dense table" style={{ display: 'none' }}>
                <TableHead>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'left' }} colSpan={5}>
                      Report For: GST Report
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'left' }} colSpan={5}>
                      Company Name : _Maven Tech Services Pvt. Ltd.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={28}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {excelHeader?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#454646', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.value}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{moment(fromDate).format('DD/MM/YYYY')}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{moment(toDate).format('DD/MM/YYYY')}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{stateName}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{sourceCity}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{sourceBranch}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{destCity}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{destBranch}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{paymentType}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{gstPaidBy}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{bookingType?.name}</span>
                    </TableCell>
                  </TableRow>
                  <TableRow colSpan={28}>
                    <TableCell colSpan={28}></TableCell>
                  </TableRow>
                </TableHead>

                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{
                        fontWeight: 'bold',
                        fontSize: '16px',
                        lineheight: '16px',
                        letterspacing: '0.24px',
                        fontWeight: '500',
                        textAlign: 'left',
                        color: '#444444',
                        backgroundColor: '#bfe1ff',
                        position: 'sticky',
                        top: '0px',
                      }}
                      colSpan={Object.keys(selectedFields).length + 2}
                    >
                      GST Report
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{ fontSize: '16px', fontWeight: '700', textAlign: 'left', color: '#444444', backgroundColor: '#e5f3ff' }}
                      colSpan={7}
                    >
                      Report View : Detailed
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontSize: '16px', fontWeight: '700', textAlign: 'right', color: '#444444', backgroundColor: '#e5f3ff' }}
                      colSpan={11}
                    >
                      Booking Type: GST Booking
                    </TableCell>
                  </TableRow>
                  {/* -------TableHeader--------- */}

                  <TableRow>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#bfe1ff',
                        color: '#454646',
                        fontSize: '16px',
                        fontWeight: '500',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      SN
                    </TableCell>
                    {columns
                      .filter((item) => item.isSelected)
                      .map((item, index) => (
                        <TableCell
                          className="ReportItemHead"
                          style={{
                            backgroundColor: '#bfe1ff',
                            color: '#454646',
                            fontSize: '16px',
                            fontWeight: '500',
                            textAlign: index < 9 ? 'left' : 'right',
                            whiteSpace: 'pre',
                          }}
                          colSpan={1}
                        >
                          {item.pdfHead}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={25}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '16px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '16px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {tableData?.map((item, index) => (
                      <InsideRowContentForExcel item={item} index={index} selectedFields={selectedFields} key={index} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
              <Table id="table-to-xls" className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  {
                    bookingType?.id === 0 || bookingType?.id === 1 ?

                      <TableRow>
                        <TableCell
                          className="reportTD"
                          style={{
                            // fontWeight: 'bold',
                            fontSize: '14px',
                            lineheight: '16px',
                            letterspacing: '0.24px',
                            fontWeight: '600',
                            textAlign: 'left',
                            color: '#444444',
                            backgroundColor: '#bfe1ff',
                            position: 'sticky',
                            top: '0px',
                            borderBottom: 'none',
                          }}
                          colSpan={Object.keys(selectedFields).length / 2 + 2}
                        >
                          Report View: Detailed
                        </TableCell>
                        <TableCell
                          className="reportTD"
                          style={{
                            // fontWeight: 'bold',
                            fontSize: '14px',
                            lineheight: '16px',
                            letterspacing: '0.24px',
                            fontWeight: '600',
                            textAlign: 'right',
                            color: '#444444',
                            backgroundColor: '#bfe1ff',
                            position: 'sticky',
                            top: '0px',
                            borderBottom: 'none',
                          }}
                          colSpan={Object.keys(selectedFields).length / 2 + 2}
                        >
                          Booking Type: GST Booking
                        </TableCell>
                      </TableRow> :
                      <TableRow>
                        <TableCell
                          className="reportTD"
                          style={{
                            fontWeight: 'bold',
                            fontSize: '12px',
                            lineheight: '16px',
                            letterspacing: '0.24px',
                            fontWeight: '500',
                            textAlign: 'left',
                            color: '#444444',
                            backgroundColor: '#bfe1ff',
                            position: 'sticky',
                            top: '0px',
                            borderBottom: 'none',
                          }}
                          colSpan={Object.keys(selectedFields).length + 2}
                        >
                          GST Report
                        </TableCell>
                      </TableRow>
                  }
                  {bookingType.id === 0 || bookingType.id === 1 ? (
                    <TableRow
                    // style={{ display: bookingType === 'Non-GST Booking' ? 'none' : ''}}
                    >
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#e5f3ff',
                          color: '#454646',
                          fontSize: '12px',
                          fontWeight: '500',
                          textAlign: 'right',
                          whiteSpace: 'nowrap',
                        }}
                        colSpan={1}
                      >
                        SN
                      </TableCell>
                      {columns
                        .filter((item) => item.isSelected)
                        .map((item, index) => (
                          <TableCell
                            className="ReportItemHead"
                            sx={{
                              backgroundColor: '#e5f3ff',
                              color: '#454646',
                              fontSize: '12px',
                              fontWeight: '500',
                              textAlign: index < 9 ? 'left' : 'right',
                              whiteSpace: 'pre',
                            }}
                            colSpan={1}
                          >
                            {item.pdfHead}
                          </TableCell>
                        ))}
                    </TableRow>
                  ) : (
                    ''
                  )}
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={25}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {bookingType?.id === 0
                      ? tableData?.map((item, index) => (
                        <InsideRowContentForBoth item={item} index={index} selectedFields={selectedFields} key={index} />
                      ))
                      : bookingType?.id === 1
                        ? tableDataForGST?.map((item, index) => (
                          <InsideRowContentForBoth item={item} index={index} selectedFields={selectedFields} key={index} />
                        ))
                        : tableDataForNonGST?.map((item, index) => (
                          <InsideRowContentForBoth item={item} index={index} selectedFields={selectedFields} key={index} />
                        ))}
                    {/* {tableData?.map((item, index) => (
                      <InsideRowContentForBoth item={item} index={index} selectedFields={selectedFields} key={index} />
                    ))} */}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </TableContainer>
          </Stack>
        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="ownBooingDetailed"
              type="application/pdf"
              width={'100%'}
              height="440"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}
export default DetailedTable
